/* vl-nav-active — marks the header menu entry that matches the current page
   so its underline stays on, in the desktop bar and the mobile drawer.
   See assets/vl-nav-active.css.

   The theme gives us nothing to work with: it never sets an active class,
   and the desktop dropdown labels are <summary> elements with no href. So
   each top-level entry is scored against the URL — a dropdown by the links
   it contains, a plain entry by its own — and the best match wins.

   Scores, highest first:
     exact path            e.g. /collections/yatak on the YATAK dropdown
     section prefix        e.g. /collections/yatak/anything
     same last segment     a product reached without its collection prefix,
                           /products/back-support-… vs the menu's
                           /collections/medikal-yastiklar/products/back-support-…
   A plain entry outscores a dropdown that merely happens to contain the same
   URL, which is what keeps /pages/quiz on YATAK TESTİ rather than on YATAK.

   The drawer lists the same seven entries but as plain links straight to the
   collections, with none of the product links the desktop dropdowns carry.
   On a product page it would therefore match nothing, so when the drawer
   cannot decide for itself it follows the bar's winner by label. */
(function () {
  var path = location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return;
  var seg = path.split('/').pop();

  function collect(ul) {
    if (!ul) return [];
    return Array.prototype.map.call(ul.children, function (li) {
      var details = li.querySelector(':scope > hdt-header-menu > details');
      var label = details
        ? details.querySelector(':scope > summary, :scope > .hdt-menu-link')
        : li.querySelector(':scope > a.hdt-menu-link');
      if (!label) return null;
      return {
        label: label,
        links: details ? details.querySelectorAll('a[href]') : [label],
        isDropdown: !!details,
        text: label.textContent.replace(/\s+/g, ' ').trim()
      };
    }).filter(Boolean);
  }

  function score(entry) {
    var best = 0;
    Array.prototype.forEach.call(entry.links, function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return;
      var p = href.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
      var s = 0;
      if (p === path) s = p.length + 1000;
      else if (path.indexOf(p + '/') === 0) s = p.length;
      else if (seg && p.split('/').pop() === seg) s = 1;
      if (s > best) best = s;
    });
    if (best && !entry.isDropdown) best += 1;
    return best;
  }

  function pick(entries) {
    var best = null, bestScore = 0;
    entries.forEach(function (e) {
      var s = score(e);
      if (s > bestScore) { bestScore = s; best = e; }
    });
    return best;
  }

  var bar = pick(collect(document.getElementById('hdt-nav-ul')));
  if (bar) bar.label.classList.add('vl-nav-current');

  var drawerEntries = collect(document.getElementById('hdt-nav-ul-mb'));
  var drawer = pick(drawerEntries);
  if (!drawer && bar) {
    drawer = drawerEntries.filter(function (e) { return e.text === bar.text; })[0];
  }
  if (drawer) drawer.label.classList.add('vl-nav-current');
})();
